import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import { WebPageSchema } from '@/components/feature/SchemaOrg';
import Breadcrumb, { BreadcrumbWrapper } from '@/components/feature/Breadcrumb';
import VideoCard from '@/components/feature/VideoCard';
import { categories } from '@/mocks/categories';
import { videos } from '@/mocks/videos';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();
  const [activeCategory, setActiveCategory] = useState(slug || 'reboju');

  useEffect(() => {
    if (slug) setActiveCategory(slug);
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [slug]);

  const currentCategory = categories.find((c) => c.slug === activeCategory);
  const categoryVideos = videos.filter((v) => v.category === activeCategory);

  const handleSwitchCategory = (newSlug: string) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setTimeout(() => navigate(`/category/${newSlug}`), 150);
  };

  const handleVideoClick = (videoSlug: string) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setTimeout(() => navigate(`/article/${videoSlug}`), 150);
  };

  return (
    <>
      <SEOHead
        title={`${currentCategory?.name || '分类浏览'} - 嫩草视频高清在线观看`}
        description={currentCategory?.description || '嫩草视频分类浏览，海量影视资源按分类整理。'}
        keywords={`嫩草视频,${currentCategory?.name || '分类'},高清在线观看,热播剧,电影全集`}
        canonicalUrl={`https://www.nencao.com/category/${activeCategory}`}
      />
      <WebPageSchema
        title={`${currentCategory?.name || '分类浏览'} - 嫩草视频`}
        description={currentCategory?.description || '嫩草视频分类浏览'}
        url={`https://www.nencao.com/category/${activeCategory}`}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-16">
          <BreadcrumbWrapper>
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: '分类浏览', href: '/category/reboju' },
                { label: currentCategory?.name || '' },
              ]}
            />
          </BreadcrumbWrapper>

          <section className="py-10 md:py-14 bg-background-50">
            <div className="max-w-[1400px] mx-auto px-4 md:px-6">
              <div className="mb-8">
                <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
                  {currentCategory?.name}高清在线观看
                </h1>
                <p className="text-foreground-600 text-sm">
                  共 <strong>{categoryVideos.length}</strong> 部{currentCategory?.name}资源
                </p>
              </div>

              <div className="flex items-center gap-2 mb-8 overflow-x-auto pb-2 flex-wrap">
                {categories.map((cat) => (
                  <button
                    key={cat.id}
                    onClick={() => handleSwitchCategory(cat.slug)}
                    className={`px-4 py-2 text-sm rounded-full transition-all whitespace-nowrap cursor-pointer ${
                      activeCategory === cat.slug
                        ? 'bg-primary-500 text-background-50 font-medium'
                        : 'bg-background-100 text-foreground-600 hover:bg-background-200 border border-background-200'
                    }`}
                  >
                    <div className="w-4 h-4 flex items-center justify-center inline-block mr-1.5">
                      <i className={`${cat.icon} text-xs`}></i>
                    </div>
                    {cat.name}
                  </button>
                ))}
              </div>

              {categoryVideos.length > 0 ? (
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                  {categoryVideos.map((video) => (
                    <VideoCard key={video.id} video={video} />
                  ))}
                </div>
              ) : (
                <div className="text-center py-20">
                  <div className="w-20 h-20 flex items-center justify-center mx-auto mb-4 rounded-full bg-background-100 text-foreground-400">
                    <i className="ri-video-line text-2xl"></i>
                  </div>
                  <p className="text-foreground-500">该分类暂无内容，敬请期待</p>
                </div>
              )}
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}